<div class="pl-32 pr-32">
  <app-breadcrumb [items]="breadcrumbItems" class="breadcrumb"></app-breadcrumb>
</div>

<div class="flex flex-row justify-between header-background">
  <div class="flex flex-row flex-auto pl-32 pt-16 pr-32 pb-16">
    <div class="flex flex-row pt-6">
      <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
        (click)="goToRunbook()"></mat-icon>
    </div>
    <div class="flex flex-col flex-auto justify-between pl-24">
      <div class="flex flex-row justify-between mb-8">
        <div class="mat-subtitle-1 fw-600 fs-20 mb-0">
            @if(isEdit) {
              {{ 'RUNBOOK.EDIT_RUNBOOK' | transloco }}
            } @else {
              {{ 'INSTANCE_DETAILS.CREATE_RUNBOOK' | transloco }}
            }
        </div>
      </div>
      <div class="flex flex-row items-center mt--4">
      <div class="fs-14 fw-400 pr-16 flex items-center">{{ 'INSTANCE_DETAILS.ENVIRONMENT_NAME' | transloco }}: <span *ngIf="instance; else loader" class="ml-4">{{instance?.name}}</span> 
      <span class="vertical-dash ml-4"> 
        @if(isEdit){ 
          | {{ 'RUNBOOK.VERSION' | transloco }}: {{this.editData?.componentVersion}}
        }
      </span>
      </div>         
       <ng-template #loader>
          <div class="pl-6 skeleton-loader pr-16">
            <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="ml-32 mr-32">
  <div class="flex items-center steper-section mt-16 mb-16">
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === -1, 'visited': !runbookForm?.invalid && runbookForm?.touched}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === -1, 'visited-border': !runbookForm?.invalid && runbookForm?.touched}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="(!runbookForm?.invalid && runbookForm?.touched) && currentStep !== -1" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === -1, 'default-style': currentStep !== -1 && !runbookForm?.touched}">{{'INSTANCE_DETAILS.CREATE'| transloco}}</div>
      </div>
      <span class="horizontal-line -ml-[4px] -mr-[33px]"></span>
    </div>
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 0, 'visited': installationSpecificationForms && !installationSpecificationForms[0]?.formGroup?.invalid && installationSpecificationForms[0]?.formGroup?.touched}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === 0, 'visited-border': installationSpecificationForms && !installationSpecificationForms[0]?.formGroup?.invalid && installationSpecificationForms[0]?.formGroup?.touched}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="(installationSpecificationForms && !installationSpecificationForms[0]?.formGroup?.invalid && installationSpecificationForms[0]?.formGroup?.touched) && currentStep !== 0" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === 0, 'default-style': currentStep !== 0 && (!installationSpecificationForms || !installationSpecificationForms[0]?.formGroup?.touched)}">{{'INSTANCE_DETAILS.PARAMETERS'| transloco}}</div>
      </div>
      <span class="horizontal-line -ml-[20px] -mr-[26px]"></span>
    </div>
        <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 1, 'visited': summaryVisited}">
      <div class="flex flex-col items-center justify-center">
        <div class="border" [ngClass]="{'current-border': currentStep === 1, 'visited-border': summaryVisited}"><div class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center"><mat-icon *ngIf="summaryVisited && currentStep !== 1" svgIcon="done" class="icon-sm"></mat-icon></div></div>
        <div class="mat-subtitle-2 mb-0 fs-14 mt-8 fw-500" [ngClass]="{'fw-600': currentStep === 1, 'default-style': currentStep !== 1}">{{'INSTANCE_DETAILS.SUMMARY'| transloco}}</div>
      </div>
    </div>
  </div>

  @if (currentStep === -1) {
    <div class="section-border">
      <form [formGroup]="runbookForm" class="p-24">
        <div class="flex flex-row">
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.NAME' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.NAME' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': isEdit}" class="flex flex-col mt-4">
              <input [ngClass]="{'dropdown-disabled': isEdit}" [formControl]="runbookForm.get('name')" class="name-container fw-400 h-34" placeholder="{{'INSTANCE_DETAILS.ENTER_NAME' | transloco}}" type="text">
              <app-error [control]="runbookForm.get('name')"></app-error>
            </div>
          </div>
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.DESCRIPTION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': isEdit}" class="flex flex-col mt-4">
              <input [ngClass]="{'dropdown-disabled': isEdit}" [formControl]="runbookForm.get('description')" class="name-container description fw-400 h-34" placeholder="{{'INSTANCE_DETAILS.DESCRIPTION_HERE' | transloco}}" type="text">
              <app-error [control]="runbookForm.get('description')"></app-error>
            </div>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'RUNBOOK.OPERATION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'RUNBOOK.OPERATION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': isEdit}">
            <mat-select [ngClass]="{'dropdown-disabled': isEdit}" (closed)="dropdownClose()" class="runbook-dropdown pt-0" #matSelect [placeholder]="'RUNBOOK.CHOOSE_OPERATION' | transloco" [formControl]="runbookForm.get('componentName')" panelClass="runbook-dropdown" (click)="resetFilter()" (selectionChange)="componentSelection($event)">
              <div *ngIf="!componentsLoading" class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" [ngModelOptions]="{standalone: true}" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
                <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
              </div>
              <mat-option *ngIf="componentsLoading">
                <div class="flex items-center justify-center spinner-width mb-16 mt-16">
                  <mat-spinner class="mr-8" diameter="20"
                    color="primary"
                    mode="indeterminate">
                  </mat-spinner>
                </div>
              </mat-option>
              <mat-option class="fs-14 flex justify-center" *ngIf="!componentsLoading && filteredComponents?.length === 0">{{'RUNBOOK.NO_OPERATION_FOUND' | transloco}}</mat-option>
              <mat-option *ngFor="let component of filteredComponents" [value]="component">{{component.displayName}}</mat-option>
            </mat-select>
            </div>
            <app-error [control]="runbookForm.get('componentName')"></app-error>
          </div>
          <div class="flex flex-col mb-24 mr-32">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'INSTANCE_DETAILS.VERSION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.VERSION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div [ngClass]="{'input-disabled': isEdit}">
            <mat-select [ngClass]="{'dropdown-disabled': isEdit}" class="runbook-dropdown pt-0" #matSelect [placeholder]="'INSTANCE_DETAILS.CHOOSE_VERSION' | transloco" [formControl]="runbookForm.get('componentVersion')">
              <mat-option class="fs-14 flex justify-center" *ngIf="versions?.length === 0">{{selectedComponent ? ('INSTANCE_DETAILS.NO_VERSION_FOUND' | transloco) : ('INSTANCE_DETAILS.CHOOSE_COMPONENT_TO_SEE_VERSIONS' | transloco)}}</mat-option>
              <mat-option *ngFor="let version of versions" [value]="version">{{version?.version}}</mat-option>
            </mat-select>
            </div>
            <app-error [control]="runbookForm.get('componentVersion')"></app-error>
          </div>
        </div>
      </form>
    </div>

  } @else if (currentStep === 0) {
    <div *ngIf="installationSpecificationForms && selectedComponent?.inputSpec; else showMessage" class="section-border ques-section p-24">
      <app-dynamic-form *ngFor="let installationSpecificationForm of installationSpecificationForms" [dynamicFormModel]="installationSpecificationForm">
      </app-dynamic-form>
    </div>
    <ng-template #showMessage>
      <div class="flex flex-col items-center justify-center section-border pt-32 pb-32 fs-16">
        <img src="/assets/images/feature_not_available.png">
        <div class="mt-10 feature-not-avaliable">
          {{'INSTANCE_DETAILS.PARAMETER_SPECIFICATION_NOT_AVAILABLE' | transloco}}
        </div>
      </div>
    </ng-template>

  } @else if (currentStep === 1) {
    <div class="flex flex-col sumary-section mb-16 section-border p-16">
      <div class="flex flex-row justify-between mb-20">
        <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">{{ 'INSTANCE_DETAILS.CREATE' | transloco }}</div>
        <div class="flex justify-end cursor-pointer edit" (click)="goToStep(-1)">
          <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
          <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
        </div>
      </div>
      <div class="flex flex-row">
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.NAME' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm.get('name')?.value }}</div>
        </div>
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.DESCRIPTION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm.get('description')?.value }}</div>
        </div>
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'RUNBOOK.OPERATION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm.get('componentName')?.value?.displayName}}</div>
        </div>
        <div class="flex flex-col service-title mr-16">
          <div class="overline-font subheading fs-14 mb-8">{{ 'INSTANCE_DETAILS.VERSION' | transloco | uppercase}}</div>
          <div class="mat-body-1 blueprint-value fw-400 fs-16 word-break-word">{{ runbookForm.get('componentVersion')?.value?.version }}</div>
        </div>
      </div>
    </div>

    <div class="flex flex-col sumary-section mb-16 section-border p-16"
      *ngFor="let installationSpecificationForm of installationSpecificationForms;let i = index">
      <div class="flex flex-row justify-between mb-20">
        <div class="mat-subtitle-1 fs-16 fw-700 sub-header mb-0">{{'INSTANCE_DETAILS.PARAMETERS'| transloco}}</div>
        <div class="flex justify-end cursor-pointer edit" (click)="goToStep(i)">
          <mat-icon svgIcon="edit" class="h-16 w-16 mr-4 mt--2"></mat-icon>
          <div class="fs-16 fw-500 mt--4">{{ 'BUTTONS.EDIT' | transloco }}</div>
        </div>
      </div>
      <app-questionnaire-summary [dynamicFormModel]="installationSpecificationForm">
      </app-questionnaire-summary>
    </div>
  }

  <div class="flex flex-row justify-end mt-32 mb-32">
    <div *ngIf="currentStep !== -1" class="flex justify-items-center items-center cursor-pointer mr-32" (click)="goToStep(currentStep - 1)">
      <mat-icon class="icon-sm mr-8" svgIcon="arrow_back"></mat-icon>
      <span class="mat-subtitle-2 fw-700 cursor-pointer">{{ 'BUTTONS.PREVIOUS' | transloco }}</span>
    </div>
    <button (click)="cancelClick()" class="flex justify-items-center items-center cancel-btn mr-16 pr-16 pl-16 pt-8 pb-8">
      {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
    <button
      *ngIf="(currentStep === -1 || currentStep === 0); else showSubmitButton" [ngClass]="{'disabled': (currentStep === 0 && !selectedComponent?.inputSpec) || (isEdit && (!isNext || currentStep === 0 && !isFormDirty()))}"
      class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" type="button"
      (click)="(currentStep === 0 && !selectedComponent?.inputSpec) ? '' : goToStep(currentStep + 1)">{{ 'BUTTONS.NEXT' | transloco }}
    </button>
    <ng-template #showSubmitButton>
      <div class="button-container">
        <button class="flex justify-center items-center items-center mossgreen primary-fg" type="button" (click)="submit()">
          <span>{{('BUTTONS.SUBMIT' | transloco)}}</span>
        </button>
      </div>
    </ng-template>
  </div>
</div>
